export const selectUsersPag = (state) => state.users.users;
export const selectUsers = (state) => state.users.users.users;
export const selectExternalUsers = (state)=> state.users.externalUsers;

export const selectUsersLoading = (user) => user.users.loading;
export const selectExternalUsersLoading = (state)=> state.users.loadingExternal